export default class Config {

	constructor() {
        this._data = {};
    }        
    
    setPropertiesFromObject(obj) {
        this._data = obj;        
        if (obj.general) {
            this.setValue(Config.APPID, obj.general.appID);
            this.setValue(Config.BUILDID, obj.general.build);
            this.setValue(Config.COMMIT_HASH, obj.general.commitHash);
            this.setValue(Config.VERSION, obj.general.version);
            this.setValue(Config.ENVIRONMENT, obj.general.environment);
            this.setValue(Config.USE_MOCK_API, obj.general.useMockApi ?? false);
        }
    }
    
    getValue(label){
        return _find(this._data, label);
    }
    
    setValue(label, value){
        this._data[label] = value;
    }
    
    clear(){
        this._data = {};
    }
}


Config.APPID = "APP_ID";
Config.BUILDID = "BUILD_ID";    
Config.COMMIT_HASH = "COMMIT_HASH";
Config.ENVIRONMENT = "CFG_ENVIRONMENT";    
Config.VERSION = "VERSION";
Config.USE_MOCK_API = "USE_MOCK_API";

const _find = function(obj, path) {        
    path = path.split('.');
    var len = path.length;
                    
    for (var i=0; i<len; i++){
        obj = obj[path[i]];            
    }
    return obj;
};